import React, { FC } from "react";
import PropTypes from "prop-types";

import CardScanView, { CardScanViewProps } from "./scanview";
import ScanErrorWrapper from "./scanErrorWrapper";

const App: FC<CardScanViewProps> = ({
  logging,
  live = false,
  sessionToken,
  onSuccess,
  onEligibilityError,
  onEligibilitySuccess,
  onCancel,
  onError,
  onRetry,
  fullScreen = true,
  onProgress,
  onScanStart,
  messages,
  backsideSupport = false,
  eligibility,
  indicatorOptions = {},
  cameraPermissionModalConfig,
  closeButton,
  successIndicator,
  errorIndicator,
  autoSwitchActiveColor,
  autoSwitchInactiveColor,
  progressBarColor,
  widgetBackgroundColor,
  messageFontSize,
  messageTextColor,
  messageBackgroundColor,
  webToMobileHandoffConfig = {
    enabled: false,
    urlBase: live
      ? "https://capture.cardscan.ai"
      : "https://sandbox-capture.cardscan.ai",
    companyName: "CardScanHealth",
  },
  _internal,
  cameraOptions,
}) => {
  return (
    <ScanErrorWrapper sessionToken={sessionToken} fullScreen={fullScreen}>
      <CardScanView
        live={live}
        logging={logging}
        sessionToken={sessionToken}
        cameraPermissionModalConfig={cameraPermissionModalConfig}
        onSuccess={onSuccess}
        onEligibilitySuccess={onEligibilitySuccess}
        onEligibilityError={onEligibilityError}
        onCancel={onCancel}
        onError={onError}
        onRetry={onRetry}
        onProgress={onProgress}
        onScanStart={onScanStart}
        messages={messages}
        backsideSupport={backsideSupport}
        eligibility={eligibility}
        indicatorOptions={indicatorOptions}
        closeButton={closeButton}
        successIndicator={successIndicator}
        errorIndicator={errorIndicator}
        autoSwitchActiveColor={autoSwitchActiveColor}
        autoSwitchInactiveColor={autoSwitchInactiveColor}
        progressBarColor={progressBarColor}
        widgetBackgroundColor={widgetBackgroundColor}
        messageFontSize={messageFontSize}
        messageTextColor={messageTextColor}
        messageBackgroundColor={messageBackgroundColor}
        webToMobileHandoffConfig={webToMobileHandoffConfig}
        _internal={_internal}
        cameraOptions={cameraOptions}
      />
    </ScanErrorWrapper>
  );
};

App.propTypes = {
  logging: PropTypes.oneOf([
    "off",
    "normal",
    "verbose",
    "detector",
    "everything",
  ]),
  live: PropTypes.bool,
  sessionToken: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onProgress: PropTypes.func,
  onScanStart: PropTypes.func,
  backsideSupport: PropTypes.bool,
  cameraPermissionModalConfig: PropTypes.shape({}),
  webToMobileHandoffConfig: PropTypes.shape({}),
  _internal: PropTypes.shape({}),
};

App.defaultProps = {
  cameraPermissionModalConfig: { enabled: true },
  webToMobileHandoffConfig: {
    enabled: false,
    urlBase: "capture.cardscan.ai",
    companyName: "CardScanHealth",
  },
};

export default App;
